import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { NOTICEBOARD } from '@constants/routes';

const NoticeboardPage = lazy(
  () => import('./pages/noticeboard/NoticeboardPage')
);

export const NoticeboardRoutes: RouteObject[] = [
  {
    path: NOTICEBOARD.NOTICEBOARD,
    element: <NoticeboardPage />
  }
];

export default NoticeboardRoutes;
